/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{cursor:pointer}.ca-close[_ngcontent-%COMP%]{color:red}.ca-warning[_ngcontent-%COMP%]{color:orange}.ca-check[_ngcontent-%COMP%]{color:green}i[_ngcontent-%COMP%]{display:block;width:20px;height:20px;text-align:center}"];
export { styles as styles };
